module.exports = __webpack_public_path__ + "img/todo3.aea8fe3e.svg";